import { Alert, Box, styled } from '@mui/material';

export const CompanyDataContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '500px',
  gap: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    minWidth: theme.spacing(60)
  },
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
    width: '100%'
  },
  '@media (max-height: 700px)': {
    gap: theme.spacing(2)
  }
}));

export const InfoAlert = styled(Alert)(() => ({
  color: '#7315E5',
  backgroundColor: '#D7CCE5',
  '& .MuiAlert-icon': {
    color: '#7315E5'
  }
}));

export const CNPJAndSectorContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(3)
  }
}));

export const CompanyDetailsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3)
}));
